module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/.pnpm/ts-loader@9.5.2_typescript@5.8.2_webpack@5.98.0_webpack-cli@5.1.4_/node_modules/ts-loader/index.js??ruleSet[1].rules[7]!./cg-category-card.ts"));
	}, "elements");
}